"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = isEmpty;
exports.isEmptyArray = isEmptyArray;
exports.isEmptyObject = isEmptyObject;

var _hasOwn = _interopRequireDefault(require("./hasOwn"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEmptyObject(value) {
  for (var _key in value) {
    if (_key === '_type' || _key === '_key') {
      continue;
    }

    if ((0, _hasOwn.default)(value, _key) && !isEmpty(value[_key])) {
      return false;
    }
  }

  return true;
}

function isEmptyArray(value) {
  for (var i = 0; i < value.length; i++) {
    if (isEmpty(value[i])) {
      return true;
    }
  }

  return false;
}

function isEmpty(value) {
  if (value === undefined || value === null) {
    return true;
  }

  var type = typeof value;

  if (type === 'object') {
    return isEmptyObject(value);
  }

  if (Array.isArray(value)) {
    return isEmptyArray(value);
  }

  return false;
}